import apiClient from '../utils/apiClient';

/**
 * Camera intelligence — a MICROSERVICE the product connects to, per
 * facility (2026-08-29). Provider-neutral: the facility's chosen engine
 * URL + key live on its connection record server-side. Nothing here talks
 * to an engine directly: every call goes to the server-side passthrough,
 * which checks facility access, attaches this facility's encrypted key,
 * and relays an ALLOWLISTED engine path. Keys never reach the browser.
 */

const engine = (method, facilityId, path, body) =>
  apiClient.request({
    method,
    url: `/api/camera-engine/panel/engine/${path}`,
    params: { facility_id: facilityId },
    ...(body !== undefined ? { data: body } : {}),
  });

const camerasService = {
  // Three-state panel: connect | setup | ready | unreachable.
  panel: (facilityId) =>
    apiClient.get('/api/camera-engine/panel', { params: { facility_id: facilityId } }),
  verify: (facilityId) =>
    apiClient.post('/api/camera-engine/panel/verify', { facility_id: facilityId }),

  // Engine module views (camera tenant handshake §2.3, §2.4, §4).
  brief: (facilityId, date) =>
    engine('GET', facilityId, date ? `brief?date=${encodeURIComponent(date)}` : 'brief'),
  openEvents: (facilityId, limit = 50) =>
    engine('GET', facilityId, `events?open_only=true&limit=${limit}`),
  feedback: (facilityId, eventId, verdict, note = '') =>
    engine('POST', facilityId, `events/${eventId}/feedback`, { verdict, note }),
  listCameras: (facilityId) => engine('GET', facilityId, 'cameras'),
  createCamera: (facilityId, payload) => engine('POST', facilityId, 'cameras', payload),
  updateCamera: (facilityId, cameraId, payload) =>
    engine('PATCH', facilityId, `cameras/${cameraId}`, payload),
  deleteCamera: (facilityId, cameraId) => engine('DELETE', facilityId, `cameras/${cameraId}`),
  listActors: (facilityId) => engine('GET', facilityId, 'actors'),
  setupRequirements: (facilityId) => engine('GET', facilityId, 'setup/requirements'),
};

export default camerasService;
